export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
      text: 'NEW',
    },
  },
  {
    component: 'CNavTitle',
    name: 'Оплаты',
  },
  {
    component: 'CNavItem',
    name: 'Добавить оплату',
    to: '/payments/add',
    icon: 'cil-wallet',
  },
  {
    component: 'CNavItem',
    name: 'Корректировка',
    to: '/payments/correcting',
    icon: 'cil-exposure',
  },
  {
    component: 'CNavItem',
    name: 'Реестр оплат',
    to: '/payments/registry',
    icon: 'cil-list',
  },
  {
    component: 'CNavTitle',
    name: 'Отчёты',
  },
  {
    component: 'CNavItem',
    name: 'Обновить показания',
    to: '/reports/update-counter',
    icon: 'cil-reload',
  },
  {
    component: 'CNavItem',
    name: 'Печать извещений',
    to: '/reports/notice',
    icon: 'cil-share-boxed',
  },
  {
    component: 'CNavItem',
    name: 'История абонента',
    to: '/reports/history',
    icon: 'cil-history',
  },
  {
    component: 'CNavItem',
    name: 'По абонентам',
    to: '/reports/customers',
    icon: 'cil-address-book',
  },
  {
    component: 'CNavItem',
    name: 'По улицам',
    to: '/reports/streets',
    icon: 'cil-sitemap',
  },
  {
    component: 'CNavItem',
    name: 'По контролёрам',
    to: '/reports/controllers',
    icon: 'cil-contact',
  },
  {
    component: 'CNavItem',
    name: 'Закрыть отчёт',
    to: '/reports/close',
    icon: 'cil-X',
  },
  {
    component: 'CNavTitle',
    name: 'База',
  },
  {
    component: 'CNavItem',
    name: 'Абоненты',
    to: '/customers',
    icon: 'cil-group',
  },
  {
    component: 'CNavItem',
    name: 'Участки',
    to: '/uchastki',
    icon: 'cil-puzzle',
  },
  {
    component: 'CNavItem',
    name: 'Улицы',
    to: '/streets',
    icon: 'cil-sitemap',
  },
  {
    component: 'CNavItem',
    name: 'Тарифы',
    to: '/tariffs',
    icon: 'cil-library',
  },
  {
    component: 'CNavItem',
    name: 'Контроллеры',
    to: '/controllers',
    icon: 'cil-contact',
  },
  {
    component: 'CNavTitle',
    name: 'Персонал',
  },
  {
    component: 'CNavItem',
    name: 'Список пользователей',
    to: '/users',
    icon: 'cil-contact',
  },
  {
    component: 'CNavItem',
    name: 'Оплаты кассиров',
    to: '/userpays',
    icon: 'cil-money',
  },
  {
    component: 'CNavTitle',
    name: 'Настройки',
  },
  {
    component: 'CNavItem',
    name: 'Основные',
    to: '/settings-general',
    icon: 'cil-settings',
  },
  {
    component: 'CNavItem',
    name: 'Функционал программы',
    to: '/settings-program',
    icon: 'cil-settings',
  },
  {
    component: 'CNavItem',
    name: 'Организация',
    to: '/settings-organization',
    icon: 'cil-settings',
  },
]
